import './styles.scss';

import { Button, Text } from '@fragments';
import {
    IconArrowUpRight,
    IconBell,
    IconSearch,
    IconUserCircle,
} from '@tabler/icons-react';

import MyCardsCard from './components/MyCardsCard';
import BudgetOverview from './components/BudgetOverview';
import SpendingSummary from './components/SpendingSummary';
import Exchange from './components/Exchange';
import SpendingLimit from './components/SpendingLimit';
import MetricSnapshotCard from './components/MetricSnapshotCard';
import QuickTransfer from './components/QuickTransfer';
import RecentTransactionsTabbed from './components/RecentTransactionsTabbed';
import MySubscriptions from './components/MySubscriptions';
import SavedActions from './components/SavedActions';
import CreditScore from './components/CreditScore';
import MajorExpenses from './components/MajorExpenses';
import RecentTransactionsTable from './components/RecentTransactionsTable';

function Avatar({ small = false }) {
    return (
        <span className={`cards-examples__avatar${small ? ' cards-examples__avatar--small' : ''}`}>
            <IconUserCircle />
        </span>
    );
}

export default function CardsView() {
    return (
        <div className="cards-examples">
            <main className="cards-examples__main">
                <header className="cards-examples__topbar">
                    <div className="cards-examples__welcome">
                        <Avatar />
                        <div>
                            <Text.h5 weight={500} contrast={10}>Arthur Taylor</Text.h5>
                            <Text.span contrast={6}>Welcome back to Apex</Text.span>
                        </div>
                    </div>

                    <div className="cards-examples__toolbar">
                        <Button icon={<IconSearch />} variant="text" color="inverse" size="small" />
                        <Button icon={<IconBell />} variant="text" color="inverse" size="small" />
                        <Button color="primary" size="medium" endIcon={<IconArrowUpRight />}>
                            Move Money
                        </Button>
                    </div>
                </header>

                <section className="cards-examples__grid" aria-label="Finance cards">
                    <div className="cards-examples__top-card">
                        <MyCardsCard />
                    </div>

                    <div className="cards-examples__wide-card">
                        <BudgetOverview />
                    </div>

                    <div className="cards-examples__summary-card">
                        <SpendingSummary />
                    </div>

                    <div className="cards-examples__exchange-card">
                        <Exchange />
                    </div>

                    <SpendingLimit />

                    <div className="cards-examples__metric-stack">
                        <MetricSnapshotCard type="expenses" />
                        <MetricSnapshotCard type="balance" />
                    </div>

                    <QuickTransfer />
                    <RecentTransactionsTabbed />
                    <MySubscriptions />
                    <SavedActions />
                    <CreditScore />
                    <MajorExpenses />
                </section>

                <div className="cards-examples__table">
                    <RecentTransactionsTable />
                </div>
            </main>
        </div>
    );
}
